// Overlay on surface elements
import styled from "vue-styled-components";

export const Overlay = styled('div', {
    // Optional
    color: String,
})`
        background: ${props => props.color || props.theme.primary};
        content: "";
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        position: absolute;
        opacity: 0;
        transition: all .25s ease;
`;

export const PrimaryOverlay = styled('div')`
        background: ${props => props.color || props.theme.on_primary};
`.withComponent(Overlay);

export const SurfaceOverlay = styled('div')`
        background: ${props => props.color || props.theme.on_surface};
`.withComponent(Overlay);


